if (!customElements.get('quiet-editorial-product')) {
  customElements.define('quiet-editorial-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-qe-track]');
      this.slides = [...this.querySelectorAll('[data-media-id]')];
      this.thumbs = [...this.querySelectorAll('[data-qe-thumb]')];
      this.dialog = this.querySelector('dialog');
      this.select = this.querySelector('[data-qe-variant]');
      this.variants = JSON.parse(this.querySelector('[data-qe-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-qe-strings]').textContent);
      this.index = 0;
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.showMedia(index, true), { signal }));
      this.querySelectorAll('[data-qe-step]').forEach(button => button.addEventListener('click', () => this.showMedia(this.index + Number(button.dataset.qeStep), true), { signal }));
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.showMedia(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.updateGallery();
        });
      }, { signal, passive: true });
      this.querySelectorAll('[data-qe-zoom]').forEach(button => button.addEventListener('click', () => {
        this.focusBeforeZoom = button;
        this.zoomIndex = [...this.querySelectorAll('[data-qe-zoom]')].indexOf(button);
        this.showZoom(this.zoomIndex);
        this.dialog.showModal();
      }, { signal }));
      this.querySelector('[data-qe-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog.addEventListener('close', () => this.focusBeforeZoom?.focus(), { signal });
      this.dialog.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.showZoom(this.zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.querySelectorAll('[data-qe-zoom-step]').forEach(button => button.addEventListener('click', () => this.showZoom(this.zoomIndex + Number(button.dataset.qeZoomStep)), { signal }));
      this.select.addEventListener('change', () => this.updateVariant(true), { signal });
      window.addEventListener('popstate', () => {
        const variantId = new URL(location.href).searchParams.get('variant');
        if (this.variants.some(variant => String(variant.id) === variantId)) this.select.value = variantId;
        this.updateVariant(false);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.showMedia(this.index));
      this.resizeObserver.observe(this.track);
      this.updateVariant(false);
      this.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
        this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      }, { signal }));
    }
    showMedia(index, animate = false) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.updateGallery();
    }
    updateGallery() {
      this.thumbs.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.index)));
      const counter = this.querySelector('[data-qe-counter]');
      if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelectorAll('[data-qe-step]').forEach(button => { button.disabled = Number(button.dataset.qeStep) < 0 ? this.index === 0 : this.index === this.slides.length - 1; });
      this.slides.forEach((slide, index) => { if (index !== this.index) slide.querySelectorAll('video').forEach(video => video.pause()); });
    }
    showZoom(index) {
      const images = [...this.querySelectorAll('[data-qe-zoom]')];
      if (!images.length) return;
      this.zoomIndex = (index + images.length) % images.length;
      const button = images[this.zoomIndex];
      const image = this.dialog.querySelector('img');
      image.src = button.dataset.qeZoom;
      image.alt = button.querySelector('img').alt;
    }
    updateVariant(updateUrl) {
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      if (!variant) return;
      this.querySelector('[data-qe-price]').textContent = variant.price;
      this.querySelector('[data-qe-mobile-price]').textContent = variant.price;
      const mobileButton = this.querySelector('[data-qe-mobile-add]');
      mobileButton.disabled = !variant.available;
      mobileButton.textContent = variant.available ? this.strings.add : this.strings.soldOut;
      const compare = this.querySelector('[data-qe-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      const button = this.querySelector('[name=add]');
      button.disabled = !variant.available;
      button.setAttribute('aria-disabled', String(!variant.available));
      this.querySelector('[data-qe-add-label]').textContent = variant.available ? this.strings.add : this.strings.soldOut;
      this.querySelector('[data-qe-stock]').textContent = variant.available ? '' : this.strings.soldOut;
      this.querySelector('[data-qe-express]').hidden = !variant.available;
      const quantity = this.querySelector('[name=quantity]');
      const rule = variant.quantityRule || {};
      quantity.min = rule.min || 1;
      quantity.step = rule.increment || 1;
      if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
      const minimum = Number(quantity.min);
      const maximum = Number(quantity.max) || Infinity;
      if (Number(quantity.value) < minimum || Number(quantity.value) > maximum) quantity.value = minimum;
      const mediaIndex = this.slides.findIndex(slide => String(variant.mediaId) === slide.dataset.mediaId);
      if (mediaIndex >= 0) this.showMedia(mediaIndex);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
